import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject } from "rxjs";
import { FilterType } from "../../types/shared/filter.type";
import { Observable } from "rxjs";
import { SortType } from "../../types/shared/sort.type";

export class BaseDataSource<T> extends DataSource<T> {
    rows: any[];
    collectionList: BehaviorSubject<Array<T>> = new BehaviorSubject<Array<T>>(
        []
    );
    totalNumberOfRecords: number;
    loading = false;
    filter: FilterType = new FilterType();

    constructor(private requestService: any) {
        super();
    }

    connect(collectionViewer?: CollectionViewer): Observable<T[]> {
        return this.collectionList;
    }

    getList() {
        const self = this;

        if (!self.requestService) {
            return;
        }

        self.loading = true;

        self.totalNumberOfRecords += self.filter.pageSize;
        self.requestService.getList(self.filter).subscribe((res) => {
            //  self.totalNumberOfRecords = res.totalNumberOfRecords;
            // console.log(res);
            // console.log(res.list);
            self.collectionList.next(res.list);
            self.rows = res.list;
            // console.log(self.rows);
            self.loading = false;
        });
    }

    sortData(field: string, direction: string) {
        this.filter.sort = [];

        if (direction !== "") {
            this.filter.sort.push(new SortType(field, direction));
        }

        this.getList();
    }

    create(data: T): Observable<boolean> {
        return this.requestService.create(data);
    }

    update(data: T): Observable<boolean> {
        return this.requestService.update(data);
    }

    delete(id: number): Observable<boolean> {
        return this.requestService.delete(id);
    }

    activationToggle(id: number): Observable<boolean> {
        return this.requestService.activationToggle(id);
    }

    disconnect(collectionViewer?: CollectionViewer): void {}
}
